import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class RouteGaurdGuard  {
    constructor(private router: Router) { }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {
        // Check if the URL is 'workspace/workspace-setting/main' and 'lastVistedWorkspace' exists
        if (
            state.url.includes('workspace/workspace-setting/main') ||
            state.url.includes('project/project-setting') ||
            state.url.includes('/workspace/access-control/main')
        ) {
            const lastVistedWorkspace = localStorage.getItem('lastVisited_workspace');

            if (lastVistedWorkspace !== null) {
                // If 'lastVistedWorkspace' exists, allow access to the route
                return true;
            } else {
                // If 'lastVistedWorkspace' doesn't exist, navigate to '/project'
                this.router.navigate(['/workspaces/dashboard']);
                return false;
            }
        }
        // Check if the project exists
        const projectExists = localStorage.getItem('selectedProject');
        if (projectExists !== null) {
            // Allow access to the route
            return true;
        } else {
            // Navigate to a specific URL
            this.router.navigate(['/projects/main']);
            // Prevent access to the route
            return false;
        }
    }
}
